import script from "./MyMaterialDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MyMaterialDialog.vue?vue&type=script&setup=true&lang=js"

import "./MyMaterialDialog.vue?vue&type=style&index=0&id=7a5ede3e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a5ede3e"]])

export default __exports__